export default "__VITE_ASSET__DSk82P6s__"